const DEFAULT_SCRIPT_ORIGINS = [
  "https://t.me",
  "https://telegram.org",
  "https://api.telegram.org",
  "https://monetag.com",
  "https://libtl.com",
  "https://alwingulla.com",
  "https://3nbf4.com",
  "https://static.cloudflareinsights.com",
];

const SCRIPT_URL_ENV_KEYS = [
  import.meta.env.VITE_TELEGRAM_WEBAPP_SDK_URL,
  import.meta.env.VITE_MONETAG_SDK_URL,
  import.meta.env.VITE_REWARDED_AD_SCRIPT_URL,
  import.meta.env.VITE_INPAGE_PUSH_SCRIPT_URL,
  import.meta.env.VITE_VIGNETTE_SCRIPT_URL,
];

const resolveOrigin = (value: string) => {
  const normalized = value.trim().startsWith("//") ? `https:${value.trim()}` : value.trim();
  try {
    return new URL(normalized, window.location.href).origin;
  } catch {
    return null;
  }
};

const createTrustedTypesPolicy = () => {
  if (typeof window === "undefined" || !window.trustedTypes) {
    return;
  }

  const trustedTypes = window.trustedTypes;

  if (typeof trustedTypes.createPolicy !== "function") {
    return;
  }

  // Check if default policy already exists - use try/catch since getPolicy may not exist
  try {
    if ((trustedTypes as unknown as { getPolicy?: (name: string) => unknown }).getPolicy?.("default")) {
      return;
    }
  } catch {
    // getPolicy not supported, continue to create policy
  }

  const allowedOrigins = new Set([window.location.origin, ...DEFAULT_SCRIPT_ORIGINS]);

  SCRIPT_URL_ENV_KEYS.forEach((scriptUrl) => {
    if (!scriptUrl) return;
    const origin = resolveOrigin(scriptUrl);
    if (origin) {
      allowedOrigins.add(origin);
    }
  });

  trustedTypes.createPolicy("default", {
    createHTML: (input) => input,
    createScript: (input) => input,
    createScriptURL: (input) => {
      const url = new URL(input, window.location.href);
      if (!allowedOrigins.has(url.origin)) {
        throw new TypeError(`Untrusted script URL origin: ${url.origin}`);
      }
      return url.toString();
    },
  });
};

createTrustedTypesPolicy();
